module.exports = __webpack_public_path__ + "img/banner-home.7118bac5.jpg";